<template>
	<div ref="el" data-component="photos-btn">
		<div class="svg-wrapper">
			<div class="inner">
				<SvgAsset v-if="url" :url="url" class="circle" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { gsap } from 'gsap'
import { SvgAsset } from '~/components/core'

import { useEnterAnimation } from '~/composables/core'

const props = defineProps({
	url: { type: [Boolean, String], default: false },
})

const el = ref(null)
const context = inject('pageContext')
const enterAnimation = useEnterAnimation()
const tl = gsap.timeline({ paused: true })

const setup = () => {}

const init = () => {
	tl.to(el.value.querySelector('.svg-wrapper .inner'), {
		rotation: 360,
		repeat: -1,
		ease: 'expo.inOut',
		duration: 3,
	})

	enterAnimation.init({
		trigger: el.value,
		timeline: tl,
		repeat: true,
	})
}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.ready.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='photos-btn'] {
	position: relative;

	display: flex;
	align-items: center;
	justify-content: center;
	width: rs(170, 120);
	height: rs(170, 120);
	border-radius: rs(170, 120);

	cursor: pointer;

	@media (hover: hover) {
		&:hover {
			.svg-wrapper {
				transform: scale(0.95);
			}
		}
	}

	.svg-wrapper {
		position: relative;
		width: rs(170, 120);
		height: rs(170, 120);

		transform-origin: center;
		transition: transform 0.5s ease(out-expo);

		:deep([data-component='svg-asset']) {
			position: relative;
			width: rs(170, 120);
			height: rs(170, 120);
		}

		.inner {
			transform-origin: center;
		}

		:deep(svg) {
			position: relative;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
